import { supabase } from './supabase';

const PLAN_RANK = {
  starter: 1,
  pro: 2,
  premium: 3,
};

const FEATURE_MIN_PLAN = {
  onlineScheduling: 'pro',
  checkin: 'pro',
  quotes: 'pro',
  timeline: 'pro',
  opportunityDashboard: 'pro',
  advancedReports: 'pro',
  teamManagement: 'pro',
  ai: 'premium',
  campaigns: 'premium',
  whatsappCrm: 'premium',
};

export function normalizePlanCode(value) {
  const normalized = String(value || 'starter')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  if (normalized.includes('premium')) return 'premium';
  if (normalized.includes('pro')) return 'pro';
  return 'starter';
}

export function canUseFeature(planCode, feature) {
  const required = FEATURE_MIN_PLAN[feature];
  if (!required) return true;
  return (PLAN_RANK[normalizePlanCode(planCode)] || 1) >= PLAN_RANK[required];
}

export async function loadOfficePlanFeatures(oficinaId) {
  if (!oficinaId) return { code: 'starter', features: {} };

  const { data: rpcData, error: rpcError } = await supabase.rpc('get_mecsync_plan_features', {
    target_oficina_id: oficinaId,
  });

  if (!rpcError && rpcData) {
    const { code = 'starter', ...features } = rpcData;
    return { code: normalizePlanCode(code), features };
  }

  const { data } = await supabase
    .from('assinaturas')
    .select('plano, planos_mecsync(codigo)')
    .eq('oficina_id', oficinaId)
    .maybeSingle();

  const planRelation = Array.isArray(data?.planos_mecsync)
    ? data.planos_mecsync[0]
    : data?.planos_mecsync;
  const code = normalizePlanCode(planRelation?.codigo || data?.plano);
  return {
    code,
    features: Object.fromEntries(Object.keys(FEATURE_MIN_PLAN).map((feature) => [
      feature,
      canUseFeature(code, feature),
    ])),
  };
}
